const SHOW_HIDE_FIELDS = ['firstPublishedPrice', 'latestPublishedPrice', 'listingPrice'];

export { SHOW_HIDE_FIELDS };